/**
 * Valan master CRUD — uses configured api instance + shared error helper (was raw axios + missing showMessage).
 */
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../utils/api";
import _ from "lodash";
import moment from "moment";
import { getSessionData } from "utils/common";
import { showMessage } from "./common.slice";
import { getAxiosErrorMessage } from "utils/httpErrors";

const initialState = {
	valansList: [],
	searchValansList: [],
	valansLoading: false,
	sortValansArr: [],
	valanSearchText: "",
	currentPageValans: 1,
	pageSizeValans: 10,
	totalRecordValans: 0,
	startApiCallValansList: true,
	isValansUpdated: false,
	valanViewEditDeleteData: {},
	valanDeleteId: "",
};

export const addValan = createAsyncThunk(
	"master/valan/add",
	(data, {dispatch}) => {
		return new Promise((resolve, reject) => {
			let {userId} = getSessionData();
			let newFinalObject = {};
			newFinalObject.id = data.id;
			newFinalObject.name = data.name;
			newFinalObject.createdBy = userId;
			newFinalObject.startDate = moment(data.startDate).format();
			newFinalObject.endDate = moment(data.endDate).format();
			newFinalObject.isDailyBilling =
				data.isDailyBilling == "No" ? false : true;
			newFinalObject.status = data.status == "Open" ? 1 : 0;
			newFinalObject.segments = data.segments.map((item) => {
				return {segmentId: item.value};
			});
			api
				.post("master/valan/save-valan", newFinalObject)
				.then(({ data }) => {
					if (data.status == 200) {
						dispatch(showMessage({ message: data.message, varient: "success" }));
						resolve(data);
					} else {
						dispatch(showMessage({ message: data.message }));
						reject(data);
					}
				})
				.catch((error) => {
					dispatch(showMessage({ message: getAxiosErrorMessage(error) }));
					reject(error);
				});
		});
	}
);

export const editValan = createAsyncThunk(
	"master/valan/edit",
	(data, {dispatch}) => {
		return new Promise((resolve, reject) => {
			let {userId} = getSessionData();
			const clientBrokerage = {};
			clientBrokerage.id = 0;
			clientBrokerage.rate = data.cRate;
			clientBrokerage.minimumRate = data.sbMinimumRate;
			clientBrokerage.intradayRate = data.cIntradayRate;
			clientBrokerage.isHigherSideOnly = data.cIsHigherSideOnly;
			clientBrokerage.minimumPercentage = data.cMinimumPercentage;
			clientBrokerage.isMinPercentageOnDelivery =
				data.cIsMinPercentageOnDelivery;
			const subBrokerBrokerage = {};
			subBrokerBrokerage.id = 0;
			subBrokerBrokerage.rate = data.sbRate;
			subBrokerBrokerage.minimumRate = data.sbMinimumRate;
			subBrokerBrokerage.intradayRate = data.sbIntradayRate;
			subBrokerBrokerage.isHigherSideOnly = data.sbIsHigherSideOnly;
			subBrokerBrokerage.minimumPercentage = data.sbMinimumPercentage;
			subBrokerBrokerage.isMinPercentageOnDelivery =
				data.sbIsMinPercentageOnDelivery;
			// segmentId
			api
				.post("master/brokerage/update-brokerage", {
					createdBy: userId,
					id: data.id,
					userId: data.userId.value,
					brokerageType: data.brokerageType == "%" ? 1 : 2,
					SegmentId: data.segmentId.value,
					script: data.isScriptWise ? data.script.value : "",
					isScriptWise: data.isScriptWise,
					clientBrokerage,
					subBrokerBrokerage,
				})
				.then(({ data }) => {
					if (data.status == 200) {
						dispatch(showMessage({ message: data.message, varient: "success" }));
						resolve(data);
					} else {
						dispatch(showMessage({ message: data.message }));
						reject(data);
					}
				})
				.catch((error) => {
					dispatch(showMessage({ message: getAxiosErrorMessage(error) }));
					reject(error);
				});
		});
	}
);

export const deleteValan = createAsyncThunk(
	"master/valan/delete",
	(data, {dispatch}) => {
		return new Promise((resolve, reject) => {
			//user info
			let {id} = data;
			api
				.delete(`master/valan/delete-valan/${id}`)
				.then(({ data }) => {
					if (data.status == 200) {
						dispatch(showMessage({ message: data.message, varient: "success" }));
						resolve(data);
					} else {
						dispatch(showMessage({ message: data.message }));
						reject(data);
					}
				})
				.catch((error) => {
					dispatch(showMessage({ message: getAxiosErrorMessage(error) }));
					reject(error);
				});
		});
	}
);

export const getValansList = createAsyncThunk(
  "master/valans/get",
  async (_, { rejectWithValue }) => {
    try {

      const { data } = await api.get("master/valan/get-valans");

      if (data.status === 200) {
        return data.data;
      }

      return [];

    } catch (error) {
      console.error("Valan API error:", error);
      return rejectWithValue(error);
    }
  }
);

export const masterSlice = createSlice({
	name: "masterValans",
	initialState,
	reducers: {
		setSearchTextValans: (state, action) => {
			state.searchTextMasterBrokerages = action.payload;
		},
		setSearchValan: (state, action) => {
			state.valansList = state.searchValansList;
			let newArray = Search(action.payload, state.valansList);
			state.valansList = newArray;
		},
		setValanSearchText: (state, action) => {
			state.valanSearchText = action.payload;
		},
		setStartPageValans: (state, action) => {
			state.currentPageBrokerages = action.payload;
		},
		setStartApiCallValansList: (state, action) => {
			state.startApiCallValansList = action.payload;
		},
		setTotalRecordValans: (state, action) => {
			state.totalRecordValans = action.payload;
		},
		setIsValansUpdated: (state, action) => {
			state.isValansUpdated = action.payload;
		},
		setValansViewData: (state, action) => {
			state.valanViewEditDeleteData = action.payload;
		},
		setSortMasterValans: (state, action) => {
			state.sortValansArr = action.payload;
		},
		setValansList: (state, action) => {
			state.valansList = action.payload;
		},
		setValansDeleteId: (state, action) => {
			state.valanDeleteId = action.payload;
		},
	},
	extraReducers: (builder) => {
	builder
		// add valan
		.addCase(addValan.pending, (state) => {
			state.valansLoading = true;
		})
		.addCase(addValan.rejected, (state) => {
			state.valansLoading = false;
		})
		.addCase(addValan.fulfilled, (state) => {
			state.isValansUpdated = true;
			state.valansLoading = false;
		})

		// get valans list
		.addCase(getValansList.pending, (state) => {
			state.startApiCallValansList = false;
			state.valansLoading = true;
		})
		.addCase(getValansList.rejected, (state) => {
			state.valansList = [];
			state.searchValansList = [];
			state.startApiCallValansList = false;
			state.valansLoading = false;
		})
		.addCase(getValansList.fulfilled, (state, action) => {
			state.startApiCallValansList = false;
			state.valansList = action.payload;
			state.searchValansList = action.payload;
			state.valansLoading = false;
		})

		// edit valan
		.addCase(editValan.pending, (state) => {
			state.isValansUpdated = false;
		})
		.addCase(editValan.rejected, (state) => {
			state.isValansUpdated = false;
		})
		.addCase(editValan.fulfilled, (state) => {
			state.isValansUpdated = true;
		})

		// delete valan
		.addCase(deleteValan.pending, (state) => {
			state.isValansUpdated = false;
		})
		.addCase(deleteValan.rejected, (state) => {
			state.isValansUpdated = false;
		})
		.addCase(deleteValan.fulfilled, (state) => {
			state.isValansUpdated = true;
		});
},
});

export const {
	setSortMasterValans,
	setStartPageValans,
	setIsValansUpdated,
	setValansViewData,
	setStartApiCallValansList,
	setValansList,
	setValanSearchText,
	setSearchValan,
	setValansDeleteId,
} = masterSlice.actions;

export default masterSlice.reducer;